'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numbro = require('numbro');

var _numbro2 = _interopRequireDefault(_numbro);

var _fitness = require('../../utils/fitness');

var _filter = require('constructicon/filter');

var _filter2 = _interopRequireDefault(_filter);

var _grid = require('constructicon/grid');

var _grid2 = _interopRequireDefault(_grid);

var _leaderboardItem = require('constructicon/leaderboard-item');

var _leaderboardItem2 = _interopRequireDefault(_leaderboardItem);

var _leaderboard = require('constructicon/leaderboard');

var _leaderboard2 = _interopRequireDefault(_leaderboard);

var _pagination = require('constructicon/pagination');

var _pagination2 = _interopRequireDefault(_pagination);

var _paginationLink = require('constructicon/pagination-link');

var _paginationLink2 = _interopRequireDefault(_paginationLink);

var _richText = require('constructicon/rich-text');

var _richText2 = _interopRequireDefault(_richText);

var _section = require('constructicon/section');

var _section2 = _interopRequireDefault(_section);

var _fitnessLeaderboard = require('../../api/fitness-leaderboard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FitnessLeaderboard = function (_Component) {
  _inherits(FitnessLeaderboard, _Component);

  function FitnessLeaderboard() {
    _classCallCheck(this, FitnessLeaderboard);

    var _this = _possibleConstructorReturn(this, (FitnessLeaderboard.__proto__ || Object.getPrototypeOf(FitnessLeaderboard)).call(this));

    _this.fetchLeaderboard = _this.fetchLeaderboard.bind(_this);
    _this.setFilter = _this.setFilter.bind(_this);
    _this.renderLeader = _this.renderLeader.bind(_this);
    _this.state = {
      status: 'fetching',
      q: null
    };
    return _this;
  }

  _createClass(FitnessLeaderboard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var refreshInterval = this.props.refreshInterval;

      this.fetchLeaderboard();
      this.interval = refreshInterval && setInterval(function () {
        return _this2.fetchLeaderboard(_this2.state.q, true);
      }, refreshInterval);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props !== prevProps) {
        this.fetchLeaderboard(this.state.q);
      }
    }
  }, {
    key: 'setFilter',
    value: function setFilter(q) {
      this.setState({ q: q });
      this.fetchLeaderboard(q);
    }
  }, {
    key: 'fetchLeaderboard',
    value: function fetchLeaderboard(q, refresh) {
      var _this3 = this;

      var _props = this.props,
          activeOnly = _props.activeOnly,
          activity = _props.activity,
          campaign = _props.campaign,
          charity = _props.charity,
          country = _props.country,
          deserializeMethod = _props.deserializeMethod,
          endDate = _props.endDate,
          excludePageIds = _props.excludePageIds,
          limit = _props.limit,
          page = _props.page,
          sortBy = _props.sortBy,
          startDate = _props.startDate,
          tagId = _props.tagId,
          tagValue = _props.tagValue,
          type = _props.type;


      !refresh && this.setState({
        status: 'fetching',
        data: undefined
      });

      (0, _fitnessLeaderboard.fetchFitnessLeaderboard)({
        activeOnly: activeOnly,
        activity: activity,
        campaign: campaign,
        charity: charity,
        country: country,
        endDate: endDate,
        limit: limit + 10,
        page: page,
        q: q,
        sortBy: (0, _fitness.formatMeasurementDomain)(sortBy),
        startDate: startDate,
        tagId: tagId,
        tagValue: tagValue,
        type: type
      }).then(function (data) {
        return _this3.removeExcludedPages(excludePageIds, data, tagId);
      }).then(function (data) {
        return data.map(deserializeMethod || _fitnessLeaderboard.deserializeFitnessLeaderboard);
      }).then(function (data) {
        return data.slice(0, limit);
      }).then(function (data) {
        _this3.setState({
          status: 'fetched',
          data: data
        });
      }).catch(function (error) {
        _this3.setState({
          status: 'failed'
        });
        return Promise.reject(error);
      });
    }
  }, {
    key: 'removeExcludedPages',
    value: function removeExcludedPages(excludePageIds, pages, tagId) {
      if (!excludePageIds) return pages;

      return pages.filter(function (page) {
        var item = (0, _fitnessLeaderboard.deserializeFitnessLeaderboard)(page);
        var id = tagId ? item.name : item.id;

        var excluded = Array.isArray(excludePageIds) ? excludePageIds : excludePageIds.split(',');

        return excluded.indexOf(id.toString()) === -1;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          status = _state.status,
          _state$data = _state.data,
          data = _state$data === undefined ? [] : _state$data;
      var _props2 = this.props,
          leaderboard = _props2.leaderboard,
          filter = _props2.filter,
          pageSize = _props2.pageSize,
          showPage = _props2.showPage;


      return _react2.default.createElement(
        'div',
        null,
        filter && _react2.default.createElement(_filter2.default, _extends({ onChange: this.setFilter }, filter)),
        status === 'fetching' || status === 'failed' ? _react2.default.createElement(_leaderboard2.default, _extends({}, leaderboard, {
          loading: status === 'fetching',
          error: status === 'failed'
        })) : data.length ? _react2.default.createElement(
          _pagination2.default,
          { max: pageSize, toPaginate: data },
          function (_ref) {
            var currentPage = _ref.currentPage,
                isPaginated = _ref.isPaginated,
                prev = _ref.prev,
                next = _ref.next,
                canPrev = _ref.canPrev,
                canNext = _ref.canNext,
                pageOf = _ref.pageOf;
            return _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                _leaderboard2.default,
                leaderboard,
                currentPage.map(_this4.renderLeader)
              ),
              pageSize && isPaginated && _react2.default.createElement(
                _section2.default,
                { spacing: { t: 0.5 } },
                _react2.default.createElement(
                  _grid2.default,
                  { align: 'center', justify: 'center' },
                  _react2.default.createElement(_paginationLink2.default, {
                    onClick: prev,
                    direction: 'prev',
                    disabled: !canPrev
                  }),
                  showPage && _react2.default.createElement(
                    _richText2.default,
                    { size: -1 },
                    pageOf
                  ),
                  _react2.default.createElement(_paginationLink2.default, {
                    onClick: next,
                    direction: 'next',
                    disabled: !canNext
                  })
                )
              )
            );
          }
        ) : _react2.default.createElement(_leaderboard2.default, _extends({}, leaderboard, { empty: true }))
      );
    }
  }, {
    key: 'renderLeader',
    value: function renderLeader(leader, i) {
      var _props3 = this.props,
          _props3$leaderboardIt = _props3.leaderboardItem,
          leaderboardItem = _props3$leaderboardIt === undefined ? {} : _props3$leaderboardIt,
          subtitleMethod = _props3.subtitleMethod;


      return _react2.default.createElement(_leaderboardItem2.default, _extends({
        key: i,
        title: leader.name,
        subtitle: subtitleMethod(leader),
        image: leader.image,
        amount: this.getMetric(leader),
        amountLabel: this.getMetricLabel(leader),
        href: leader.url,
        rank: leader.position
      }, leaderboardItem));
    }
  }, {
    key: 'getMetric',
    value: function getMetric(leader) {
      var _props4 = this.props,
          miles = _props4.miles,
          multiplier = _props4.multiplier,
          offset = _props4.offset,
          sortBy = _props4.sortBy,
          units = _props4.units;
      var _leader$totals = leader.totals,
          totals = _leader$totals === undefined ? {} : _leader$totals;


      switch (sortBy) {
        case 'activities':
          return (0, _fitness.formatActivities)((offset + totals.count) * multiplier);
        case 'duration':
          return (0, _fitness.formatDuration)((offset + totals.seconds) * multiplier);
        case 'elevation':
          return (0, _fitness.formatElevation)((offset + totals.meters) * multiplier, miles);
        default:
          var distance = (offset + leader.distance) * multiplier;
          return units ? (0, _fitness.formatDistance)(distance, miles) : (0, _numbro2.default)(distance).format('0,0');
      }
    }
  }, {
    key: 'getMetricLabel',
    value: function getMetricLabel(leader) {
      var _props5 = this.props,
          miles = _props5.miles,
          multiplier = _props5.multiplier,
          offset = _props5.offset,
          sortBy = _props5.sortBy,
          units = _props5.units;
      var _leader$totals2 = leader.totals,
          totals = _leader$totals2 === undefined ? {} : _leader$totals2;


      switch (sortBy) {
        case 'activities':
          return (0, _fitness.formatActivities)((offset + totals.count) * multiplier);
        case 'duration':
          return (0, _fitness.formatDuration)((offset + totals.seconds) * multiplier, 'full');
        case 'elevation':
          return (0, _fitness.formatElevation)((offset + totals.meters) * multiplier, miles, 'full');
        default:
          var distance = (offset + leader.distance) * multiplier;
          return units ? (0, _fitness.formatDistance)(distance, miles, 'full') : (0, _numbro2.default)(distance).format('0,0');
      }
    }
  }]);

  return FitnessLeaderboard;
}(_react.Component);

FitnessLeaderboard.propTypes = {
  /**
   * The campaign uid to fetch pages for
   */
  campaign: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * The charity uid to fetch pages for
   */
  charity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * The type of page to include in the leaderboard
   */
  type: _propTypes2.default.oneOf(['individual', 'team']),

  /**
   * The activity type of page to include in the leaderboard (walk, run, ride, hike, swim, wheelchair)
   */
  activity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * Start date filter (ISO Format)
   */
  startDate: _propTypes2.default.string,

  /**
   * End date filter (ISO Format)
   */
  endDate: _propTypes2.default.string,

  /**
   * Use imperial units (miles, feet, yards)
   */
  miles: _propTypes2.default.bool,

  /**
   * The number of records to fetch
   */
  limit: _propTypes2.default.number,

  /**
   * The number of records to show per page, disables pagination if not specified.
   */
  pageSize: _propTypes2.default.number,

  /**
   * The page to fetch
   */
  page: _propTypes2.default.number,

  /**
   * The tag ID to group the leaderboard by
   */
  tagId: _propTypes2.default.string,

  /**
   * The tag value to filter by
   */
  tagValue: _propTypes2.default.string,

  /**
   * Override the deserializeLeaderboard method
   */
  deserializeMethod: _propTypes2.default.func,

  /**
   * The type of measurement to sort by
   */
  sortBy: _propTypes2.default.oneOf(['distance', 'duration', 'elevation']),

  /**
   * Props to be passed to the Constructicon Leaderboard component
   */
  leaderboard: _propTypes2.default.object,

  /**
   * Props to be passed to the Constructicon LeaderboardItem component
   */
  leaderboardItem: _propTypes2.default.object,

  /**
   * Props to be passed to the Filter component (false to hide)
   */
  filter: _propTypes2.default.any,

  /**
   * Include distance units?
   */
  units: _propTypes2.default.bool,

  /**
   * Only show active pages?
   */
  activeOnly: _propTypes2.default.bool,

  /**
   * Offset to be applied to each page distance
   */
  offset: _propTypes2.default.number,

  /**
   * The amount to multiply each page distance by for custom conversions
   */
  multiplier: _propTypes2.default.number,

  /**
   * Interval (in milliseconds) to refresh data from API
   */
  refreshInterval: _propTypes2.default.number,

  /**
   * A function to
   */
  subtitleMethod: _propTypes2.default.func
};

FitnessLeaderboard.defaultProps = {
  activeOnly: true,
  filter: {},
  limit: 10,
  multiplier: 1,
  offset: 0,
  page: 1,
  showPage: false,
  sortBy: 'distance',
  subtitleMethod: function subtitleMethod(item) {
    return item.subtitle;
  },
  units: true
};

exports.default = FitnessLeaderboard;